import React, { createContext, useContext, useState, useEffect } from 'react';
import { getConsent, getConsentDetail, setConsent, setConsentDetail } from '../utils/consent';

const ConsentContext = createContext();

export function ConsentProvider({ children }) {
  const [consent, setConsentState] = useState(() => getConsent());
  const [consentDetail, setConsentDetailState] = useState(() => getConsentDetail());
  const [showBanner, setShowBanner] = useState(!getConsent());

  useEffect(() => {
    const handleConsentChange = (e) => {
      setConsentState(e.detail);
      setShowBanner(false);
    };

    const handleDetailChange = (e) => {
      setConsentDetailState(e.detail);
    };

    window.addEventListener('consentChanged', handleConsentChange);
    window.addEventListener('consentDetailChanged', handleDetailChange);

    return () => {
      window.removeEventListener('consentChanged', handleConsentChange);
      window.removeEventListener('consentDetailChanged', handleDetailChange);
    };
  }, []);

  const saveConsent = (value, detail) => {
    setConsent(value);
    if (detail) setConsentDetail(detail);
    setConsentState(value);
    setConsentDetailState(detail || getConsentDetail());
    setShowBanner(false);
  };

  return (
    <ConsentContext.Provider value={{ consent, consentDetail, showBanner, saveConsent, setShowBanner }}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  const context = useContext(ConsentContext);
  if (!context) {
    throw new Error('useConsent must be used within ConsentProvider');
  }
  return context;
}